import { JobMappingSourceType } from '../enums/jobMappingSourceType.enum';

export class JobDictionaryMapping {
    id: string;
    jobDictionaryId: string;
    sourceType: JobMappingSourceType;
    sourceValue: string;
    // Human-readable name resolved from the tenant's SourceNameFieldType. Null when no
    // name field is configured, or for the HrisPosition path (code-only by design).
    sourceName?: string;
    hrisJobId?: number;
    createdByUserId: string;
}

export interface JobMappingCandidate {
    sourceType: JobMappingSourceType;
    sourceValue: string;
    // See JobDictionaryMapping.sourceName — null when unconfigured or on the code-only path.
    sourceName?: string;
    occurrenceCount: number;
}

export interface BulkAssignCandidate {
    sourceType: JobMappingSourceType;
    sourceValue: string;
    hrisJobId?: number;
}

export interface BulkAssignMappingRequest {
    jobDictionaryId: string;
    candidates: BulkAssignCandidate[];
}

export enum BulkAssignOutcome {
    Mapped = 0,
    SkippedDuplicate = 1
}

export interface BulkAssignResultItem {
    sourceType: JobMappingSourceType;
    sourceValue: string;
    outcome: BulkAssignOutcome;
    jobDictionaryMappingId?: string;
}
